import { Typography, Stack } from '@mui/material';
import Image, { type StaticImageData } from 'next/image';

import AllExcluded from '../../../../../../../public/images/illustrations/resource-selection/all_excluded.png';
import AllIncluded from '../../../../../../../public/images/illustrations/resource-selection/all_included.png';

const DynamicResourcesEmptyState = ({
  title,
  description,
  illustration,
  size: size,
}: {
  title: string;
  description?: string;
  illustration: StaticImageData;
  size: 'small' | 'large';
}) => {
  return (
    <Stack
      gap={'24px'}
      marginX='40px'
      alignItems='center'
      width='320px'
      alignSelf='center'
      justifySelf='center'
    >
      <Image
        alt='All Included'
        height={size === 'small' ? 60 : 240}
        width={size === 'small' ? 60 : 240}
        src={illustration}
      />
      <Typography variant={size === 'small' ? 'subtitle1' : 'h3'}>
        {title}
      </Typography>
      {description && (
        <Typography variant='body1' textAlign='center'>
          {description}
        </Typography>
      )}
    </Stack>
  );
};

export const DynamicResourcesAllIncluded = ({
  imageSize = 'large',
  description,
}: {
  imageSize?: 'small' | 'large';
  description?: string;
}) => {
  return (
    <DynamicResourcesEmptyState
      title='All resources included automatically'
      description={description}
      illustration={AllIncluded}
      size={imageSize}
    />
  );
};

export const DynamicResourcesAllExcluded = ({
  imageSize = 'large',
  description,
}: {
  imageSize?: 'small' | 'large';
  description: string;
}) => {
  return (
    <DynamicResourcesEmptyState
      title='All resources excluded automatically'
      description={description}
      illustration={AllExcluded}
      size={imageSize}
    />
  );
};
